// 確認画面のモーダルウィンドウ
const verifyMarkup = `<div class="form-verify-wrapper" id="verifyWrapper">
<div class="form-verify-container">
  <h2 class="verify-heading">入力内容の確認</h2>
  <div id="verifyContents"></div>
  <div class="verify-btn-wrapper">
    <div class="return-column">
      <button type="button" class="form-btn outline expanded" id="verifyCloseBtn">入力画面にもどる</button>
    </div>
    <div class="exec-column">
      <button type="button" class="form-btn expanded" id="submitExecBtn"><span>内容を送信する</span></button>
    </div>
  </div>
</div>
</div>`;

// 確認画面のマークアップ
//document.body.insertAdjacentHTML('beforeend', verifyMarkup);



export const vf = {

  // 入力内容を確認するボタン
  verifyExecBtn: document.getElementById('verifyExecBtn'),

  // 内容を送信するボタン
  submitExecBtn: document.getElementById('submitExecBtn'),

  // 入力画面にもどるボタン
  close: document.getElementById('verifyCloseBtn'),

  // 確認画面モーダルウィンドウ
  verifyWrapper: document.getElementById('verifyWrapper'),

  // 確認画面のコンテンツ
  verifyContents: document.getElementById('verifyContents'),

  // 確認画面モーダルウィンドウの Wrapper に付与するモーダルウィンドウを表示するクラス名
  verifyOpenClass: 'form-verify-visible'

};



export const vfClassName = {
  parent        : '.vf-parent',
  title         : '.vf-title',
  subtitleParent: '.vf-parent-subtitle',
  subtitle      : '.vf-subtitle'
};



// フォーム要素のタイプの配列
export const typeArray = [
  [ 'text', 'number', 'password', 'tel', 'url', 'textarea' ],
  [ 'select-one', 'radio', 'checkbox' ]
];
